<template>
  <div class="introduction">
    <router-link class="moive" :to="{
      path: '/product?cate_type=1&type=cate&cat_id=5375'
    }">
      <img src="https://kw-img-1300771238.cos.ap-shanghai.myqcloud.com/1_moive.svg">
    </router-link>
    <div class="moive flex-c">
      <router-link :to="{path: '/product?cate_type=1&type=cate&cat_id=5380'}" class="intro-modle">
        <img src="https://kw-img-1300771238.cos.ap-shanghai.myqcloud.com/1_diancang.svg">
      </router-link>
      <router-link :to="{
        path: '/product?cate_type=1&type=cate&cat_id=5390'
      }" class="intro-modle">
        <img src="https://kw-img-1300771238.cos.ap-shanghai.myqcloud.com/1_cakes.svg">
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>

$width-base: calc(1.77rem * 2);
$height-base: calc(2.65rem * 2);

.introduction {
  display: flex;
  justify-content: space-between;
  margin: 0.1rem;
  font-size: 0.28rem;
}
.moive {
  width: $width-base;
  height: $height-base;
  img {
    width: 100%;
    height: 100%;
    }
  }
 .flex-c{
   display: flex;
   flex-direction: column;
   justify-content: space-between;
 }
.intro-modle{
  width: 100%;
  height: calc(1.3rem * 2);
}
</style>